import { render, staticRenderFns } from "./UserGroupDetail.vue?vue&type=template&id=281c962b&scoped=true&"
import script from "./UserGroupDetail.vue?vue&type=script&lang=js&"
export * from "./UserGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupDetail.vue?vue&type=style&index=0&id=281c962b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281c962b",
  null
  
)

export default component.exports